import React, { useCallback, useEffect, useState } from 'react';
const SPOTS_KEY = 'cortisol45_spots';
function getInitialSpots(): number {
  const stored = localStorage.getItem(SPOTS_KEY);
  if (stored) return parseInt(stored, 10);
  const spots = Math.floor(Math.random() * 20) + 35;
  localStorage.setItem(SPOTS_KEY, String(spots));
  return spots;
}
export function UrgencyBar() {
  const [spots, setSpots] = useState<number>(getInitialSpots);
  const decrementSpot = useCallback(() => {
    setSpots(prev => {
      if (prev <= 5) return prev;
      const next = prev - 1;
      localStorage.setItem(SPOTS_KEY, String(next));
      return next;
    });
  }, []);
  useEffect(() => {
    const delay = Math.floor(Math.random() * 300000) + 180000;
    const interval = setInterval(decrementSpot, delay);
    return () => clearInterval(interval);
  }, [decrementSpot]);
  return <div className="sticky top-0 z-[1000] text-center py-3 px-5 text-sm font-semibold tracking-wide text-white animate-pulse-bar" style={{
    background: 'linear-gradient(135deg, #B5382E, #D4453A)',
    boxShadow: '0 2px 12px rgba(181, 56, 46, 0.4)'
  }} role="alert" data-id="element-295">
      ⏳ Oferta de Validación: Solo para las primeras 100 mujeres
      <span className="bg-white/20 py-0.5 px-2.5 rounded-full ml-2 font-bold" data-id="element-296">
        {spots} lugares restantes
      </span>
    </div>;
}